@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';
$navItemHeight: 25px;
$navMenuPadding: 19px;

.header {
  min-height: 40px;
  margin: 11px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  [data-autopilot-system-redesign='on'] & {
    display: flex;
    height: 60px;
    min-height: 60px;
    max-height: 60px;
    padding: 17px 15px;
    margin: 0;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid var(--dark-4);
    justify-content: flex-start;
  }

  &.apMobileWeb {
    display: flex;
    padding: 15px 15px 15px 19px;
    align-items: center;
    gap: 9px;
    align-self: stretch;
    margin: 0;

    background: var(--background, #f3f5f6) !important;
  }

  > *:first-child {
    min-width: 0;
    overflow: hidden;
  }

  .rectangle {
    height: 14px;
    flex: 1 0 0;
  }

  .logoContainer {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding-left: 8px;

    img {
      height: 36px;
      min-height: 36px;
      object-fit: contain;
    }

    svg {
      height: 36px;
      width: 101px;
    }
  }
}

.sidebarContent {
  @include thinScrollbar;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  height: calc(100% - (($navItemHeight * var(--bottom-items-count, 6)) + ($navMenuPadding * 2)));
  overflow: auto;

  &.withReferralCta {
    height: calc(100% - 82px);
  }

  &.withPendingUpdates {
    height: 100%;
    padding-bottom: 120px;
  }
}

.sidebarContent {
  position: relative;
  z-index: 1;
  overflow: auto;
  background:
    /* Shadow Cover TOP */ linear-gradient(var(--default-bg) 30%, rgba(255, 255, 255, 0.02)) center top,
    /* Shadow Cover BOTTOM */ linear-gradient(rgba(255, 255, 255, 0.02), var(--default-bg) 70%) center bottom,
    /* Shadow TOP */ radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0)) center top,
    /* Shadow BOTTOM */ radial-gradient(farthest-side at 50% 300%, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0)) center bottom;

  background-repeat: no-repeat;
  background-size: 100% 40px, 100% 40px, 100% 15px, 450% 15px;
  background-attachment: local, local, scroll, scroll;

  @include for-phone-only {
    background: transparent;
    overflow: hidden;
  }

  &.apMobileWeb {
    background: var(--background, #f3f5f6) !important;
  }
}

.sidebarInner {
  @include z-index('workspaceDashboardSidebar');
  @include thinScrollbar;
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  visibility: hidden;

  &.showScrollbar {
    overflow-y: overlay;
  }

  @include for-phone-only {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }
}

.sidebarContainer {
  @include z-index('workspaceDashboardSidebar');
  width: 0;
  transition: all 0.3s ease-in-out;
  position: relative;
  opacity: 0;
  border-right: none;
  top: 0;
  left: 0;

  &.resizing {
    transition: none;
  }

  &.locked {
    opacity: 1;
  }

  &.floating {
    .screen {
      height: calc(100vh - 40px);
    }
  }

  &.floating:not(.locked) {
    @include for-tablet-portrait-up {
      @include shadow-3;
      border-radius: 0 6px 6px 0;

      height: calc(100vh - $nav-bar-height + 1px);
      opacity: 1;
    }
  }

  &.locked.focusMode {
    opacity: 0;
  }

  @include for-tablet-landscape-max {
    &.locked {
      .backdrop {
        display: block;
      }
    }
  }

  @include for-medium-phone-only {
    left: 0;
  }
}

.sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-basis: 190px;
  min-width: 190px;
  max-width: 190px;
  opacity: 0;
  transition: all 0.2s ease-in-out;
  transform: translateX(-100%);

  [data-autopilot-system-redesign='on'] & {
    border-right: 1px solid var(--dark-4);
  }

  &.resizing {
    transition: none;
  }

  &.locked,
  &.floating {
    opacity: 1;
    transform: translateX(0);
    background-color: transparent;
  }

  &.locked {
    @include for-tablet-landscape-max {
      flex-basis: $workspaceSidebarMobileWidth;
      width: 100vw;
      max-width: $workspaceSidebarMobileWidth;
      left: 10px;
      @include shadow-3;
      border-right: none;
      border-radius: 0;
      @include blur(0px);
      background: transparent;
      box-shadow: none;
      height: 100%;
      background-color: var(--default-bg);
    }

    @include for-phone-only {
      top: 0;
      left: 0;
      height: 100vh;
      border-radius: 0;
      background-color: --default-bg;
      box-shadow: 0px 0px 50px 0px #00000026;
    }

    &.resizable {
      max-width: 350px;
    }
  }

  &.floating:not(.locked) {
    height: calc(100vh - $nav-bar-height + 1px);
    border-right: none;
    border-radius: 8px;
    box-shadow: 0px 8px 24px 0px rgba(19, 21, 26, 0.12);
    @include blur(15.5px);

    @include for-tablet-landscape-max {
      flex-basis: $workspaceSidebarWidth;
      min-width: $workspaceSidebarWidth;
      max-width: $workspaceSidebarWidth;
    }
  }

  @include for-phone-only {
    background-color: var(--sidebar-background-color);
    flex-basis: $workspaceSidebarMobileWidth;
    height: 100vh;
    max-width: $workspaceSidebarMobileWidth;
    position: absolute;
    top: 0;
  }

  &:not(.locked):not(.floating) {
    pointer-events: none;
  }
}

.locked {
  .sidebarInner {
    display: flex;
    visibility: visible;
    margin-top: unset;
  }

  @include for-phone-only {
    flex-basis: $workspaceSidebarMobileWidth;
    width: 100vw;
    height: 100vh;
    max-width: $workspaceSidebarMobileWidth;
    position: absolute;
    top: 0;

    .backdrop {
      display: block;
    }
  }
}

.focusMode {
  opacity: 0;
}

.backdrop {
  @include blur(2.5px);
  background-color: var(--backdrop);
  position: fixed;
  display: none;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  @include z-index(hiddenAside);
  background-color: var(--overlay);

  @include for-phone-only {
    @include transition(0.4s);
    display: block;
    opacity: 0;

    &.locked {
      opacity: 1;
      max-width: 100vw;
      @include z-index(workspaceDashboardSidebar);
    }
  }
}

.hidden {
  display: none;

  &:hover {
    display: flex;
  }
}

.screen {
  display: flex;
  flex-direction: column;
  height: 100%;
  z-index: 1;
}

.rightButtons {
  display: flex;
  align-items: center;
  gap: 5px;
}

@include for-medium-phone-only {
  .swipeableHandle {
    height: 100%;
    width: 20px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .sidebarContainer.isMobileMd {
    @include transition(0.4s);
    width: 100vw;
    height: 100%;
    position: absolute;
    left: 0;
    transform: translateX(-100%);

    &.locked {
      transform: translateX(0);
      opacity: 1;
    }

    .sidebar {
      @include transition(0.4s);
      margin: 0;
      max-width: initial;
      width: 87vw;
      height: 100%;
      border-radius: 0;

      .sidebarInner {
        visibility: visible;
      }
    }
  }
}

.float {
  &.locked {
    .sidebar {
      width: 100vw;
      height: calc(100vh - 20px);
      position: absolute;
      top: 10px;
      left: 10px;
      @include shadow-3;
      border-right: none;
      border-radius: 8px;
      @include blur(15.5px);
      background-color: var(--default-bg);
      flex-basis: $workspaceSidebarWidth;
      min-width: $workspaceSidebarWidth;
      max-width: $workspaceSidebarWidth;
    }
  }
}

.sidebarContainer {
  &.float {
    &.locked {
      .backdrop {
        display: block;
      }
    }
  }
}
